import { render, staticRenderFns } from "./DownloadGNRE.vue?vue&type=template&id=6deed5d1&scoped=true&"
import script from "./DownloadGNRE.vue?vue&type=script&lang=js&"
export * from "./DownloadGNRE.vue?vue&type=script&lang=js&"
import style0 from "./DownloadGNRE.vue?vue&type=style&index=0&id=6deed5d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deed5d1",
  null
  
)

export default component.exports